import { Mapper } from "../../../../../base/utils/mapper";
import { CollaboratorPositionModel } from "../../../../../domain/models/configuration/company/collaboratorposition.model";
import { CollaboratorPositionEntity } from "../../entities/company/collaboratorPosition.entity";

export class CollaboratorPositionRepositoryMapper extends Mapper<CollaboratorPositionEntity, CollaboratorPositionModel> {
    mapFrom(param: CollaboratorPositionEntity): CollaboratorPositionModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: CollaboratorPositionEntity): CollaboratorPositionModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}
